/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { doctorFarmacosControllerActualizarInteraccionFarmacos } from '../fn/doctor-farmacos/doctor-farmacos-controller-actualizar-interaccion-farmacos';
import { DoctorFarmacosControllerActualizarInteraccionFarmacos$Params } from '../fn/doctor-farmacos/doctor-farmacos-controller-actualizar-interaccion-farmacos';
import { doctorFarmacosControllerCrearInteraccionFarmacos } from '../fn/doctor-farmacos/doctor-farmacos-controller-crear-interaccion-farmacos';
import { DoctorFarmacosControllerCrearInteraccionFarmacos$Params } from '../fn/doctor-farmacos/doctor-farmacos-controller-crear-interaccion-farmacos';
import { doctorFarmacosControllerEliminarInteraccionFarmacos } from '../fn/doctor-farmacos/doctor-farmacos-controller-eliminar-interaccion-farmacos';
import { DoctorFarmacosControllerEliminarInteraccionFarmacos$Params } from '../fn/doctor-farmacos/doctor-farmacos-controller-eliminar-interaccion-farmacos';
import { doctorFarmacosControllerGetInteraccionesFarmacos } from '../fn/doctor-farmacos/doctor-farmacos-controller-get-interacciones-farmacos';
import { DoctorFarmacosControllerGetInteraccionesFarmacos$Params } from '../fn/doctor-farmacos/doctor-farmacos-controller-get-interacciones-farmacos';
import { doctorFarmacosControllerGetInteraccionFarmacoByUuid } from '../fn/doctor-farmacos/doctor-farmacos-controller-get-interaccion-farmaco-by-uuid';
import { DoctorFarmacosControllerGetInteraccionFarmacoByUuid$Params } from '../fn/doctor-farmacos/doctor-farmacos-controller-get-interaccion-farmaco-by-uuid';
import { InteraccionesFarmacosDto } from '../models/interacciones-farmacos-dto';

@Injectable({ providedIn: 'root' })
export class DoctorFarmacosService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `doctorFarmacosControllerGetInteraccionesFarmacos()` */
  static readonly DoctorFarmacosControllerGetInteraccionesFarmacosPath = '/api/farmacos/interacciones';

  /**
   * Obtener el listado completo de interacciones de fármacos.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `doctorFarmacosControllerGetInteraccionesFarmacos()` instead.
   *
   * This method doesn't expect any request body.
   */
  doctorFarmacosControllerGetInteraccionesFarmacos$Response(params?: DoctorFarmacosControllerGetInteraccionesFarmacos$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<InteraccionesFarmacosDto>>> {
    return doctorFarmacosControllerGetInteraccionesFarmacos(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtener el listado completo de interacciones de fármacos.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `doctorFarmacosControllerGetInteraccionesFarmacos$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  doctorFarmacosControllerGetInteraccionesFarmacos(params?: DoctorFarmacosControllerGetInteraccionesFarmacos$Params, context?: HttpContext): Observable<Array<InteraccionesFarmacosDto>> {
    return this.doctorFarmacosControllerGetInteraccionesFarmacos$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<InteraccionesFarmacosDto>>): Array<InteraccionesFarmacosDto> => r.body)
    );
  }

  /** Path part for operation `doctorFarmacosControllerCrearInteraccionFarmacos()` */
  static readonly DoctorFarmacosControllerCrearInteraccionFarmacosPath = '/api/farmacos/interacciones';

  /**
   * Crear una nueva interacción de fármacos.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `doctorFarmacosControllerCrearInteraccionFarmacos()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  doctorFarmacosControllerCrearInteraccionFarmacos$Response(params: DoctorFarmacosControllerCrearInteraccionFarmacos$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return doctorFarmacosControllerCrearInteraccionFarmacos(this.http, this.rootUrl, params, context);
  }

  /**
   * Crear una nueva interacción de fármacos.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `doctorFarmacosControllerCrearInteraccionFarmacos$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  doctorFarmacosControllerCrearInteraccionFarmacos(params: DoctorFarmacosControllerCrearInteraccionFarmacos$Params, context?: HttpContext): Observable<void> {
    return this.doctorFarmacosControllerCrearInteraccionFarmacos$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `doctorFarmacosControllerGetInteraccionFarmacoByUuid()` */
  static readonly DoctorFarmacosControllerGetInteraccionFarmacoByUuidPath = '/api/farmacos/interacciones/{interaccionUuid}';

  /**
   * Obtener el detalle de una interacción de fármacos por UUID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `doctorFarmacosControllerGetInteraccionFarmacoByUuid()` instead.
   *
   * This method doesn't expect any request body.
   */
  doctorFarmacosControllerGetInteraccionFarmacoByUuid$Response(params: DoctorFarmacosControllerGetInteraccionFarmacoByUuid$Params, context?: HttpContext): Observable<StrictHttpResponse<InteraccionesFarmacosDto>> {
    return doctorFarmacosControllerGetInteraccionFarmacoByUuid(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtener el detalle de una interacción de fármacos por UUID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `doctorFarmacosControllerGetInteraccionFarmacoByUuid$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  doctorFarmacosControllerGetInteraccionFarmacoByUuid(params: DoctorFarmacosControllerGetInteraccionFarmacoByUuid$Params, context?: HttpContext): Observable<InteraccionesFarmacosDto> {
    return this.doctorFarmacosControllerGetInteraccionFarmacoByUuid$Response(params, context).pipe(
      map((r: StrictHttpResponse<InteraccionesFarmacosDto>): InteraccionesFarmacosDto => r.body)
    );
  }

  /** Path part for operation `doctorFarmacosControllerActualizarInteraccionFarmacos()` */
  static readonly DoctorFarmacosControllerActualizarInteraccionFarmacosPath = '/api/farmacos/interacciones/{interaccionUuid}';

  /**
   * Actualizar una interacción de fármacos por UUID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `doctorFarmacosControllerActualizarInteraccionFarmacos()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  doctorFarmacosControllerActualizarInteraccionFarmacos$Response(params: DoctorFarmacosControllerActualizarInteraccionFarmacos$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return doctorFarmacosControllerActualizarInteraccionFarmacos(this.http, this.rootUrl, params, context);
  }

  /**
   * Actualizar una interacción de fármacos por UUID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `doctorFarmacosControllerActualizarInteraccionFarmacos$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  doctorFarmacosControllerActualizarInteraccionFarmacos(params: DoctorFarmacosControllerActualizarInteraccionFarmacos$Params, context?: HttpContext): Observable<void> {
    return this.doctorFarmacosControllerActualizarInteraccionFarmacos$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `doctorFarmacosControllerEliminarInteraccionFarmacos()` */
  static readonly DoctorFarmacosControllerEliminarInteraccionFarmacosPath = '/api/farmacos/interacciones/{interaccionUuid}';

  /**
   * Eliminar una interacción de fármacos por UUID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `doctorFarmacosControllerEliminarInteraccionFarmacos()` instead.
   *
   * This method doesn't expect any request body.
   */
  doctorFarmacosControllerEliminarInteraccionFarmacos$Response(params: DoctorFarmacosControllerEliminarInteraccionFarmacos$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return doctorFarmacosControllerEliminarInteraccionFarmacos(this.http, this.rootUrl, params, context);
  }

  /**
   * Eliminar una interacción de fármacos por UUID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `doctorFarmacosControllerEliminarInteraccionFarmacos$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  doctorFarmacosControllerEliminarInteraccionFarmacos(params: DoctorFarmacosControllerEliminarInteraccionFarmacos$Params, context?: HttpContext): Observable<void> {
    return this.doctorFarmacosControllerEliminarInteraccionFarmacos$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
